<!-- @format -->
<template>
	<div style="width: 100%">
		<div class="desensitize-header">
			<el-select :model-value="value.type" placeholder="请选择校验类型" size="small" clearable @change="typeChange">
				<el-option v-for="item in desensitizeList" :key="item.type" :label="item.label" :value="item.type" />
			</el-select>
			<el-tooltip placement="top">
				<template #content>
					<ul style="list-style: none; padding-left: 0px">
						<li>全量: 该字段在资源查看状态下无法查看</li>
						<li>
							部分: 该字段在资源查看状态下从
							<span style="color: red">起始位置</span> 到 <span style="color: red">结束位置</span> 数据无法查看
						</li>
						<li>自定义: 该字段在资源查看状态下符合 <span style="color: red">自定义正则</span> 匹配的数据无法查看</li>
					</ul>
				</template>
				<el-icon><QuestionFilled /></el-icon>
			</el-tooltip>
		</div>

		<template v-if="value.type === desensitizeEnum.part">
			<div class="part-class">
				<el-input-number
					:model-value="value.startNum"
					size="small"
					placeholder="起始位置"
					controls-position="right"
					:min="0"
					@change="(e) => valueChange('startNum', e)"
				/>
				<el-input-number
					:model-value="value.endNum"
					size="small"
					placeholder="结束位置"
					controls-position="right"
					:min="0"
					@change="(e) => valueChange('endNum', e)"
				/>
			</div>
		</template>
		<template v-else-if="value.type === desensitizeEnum.custom">
			<el-input
				:model-value="value.regExp"
				placeholder="请输入正则，例如:^\d{1,3}$"
				size="small"
				class="regExpClass"
				@input="(e) => valueChange('regExp', e)"
			>
				<template #prepend>/</template>
				<template #append>/</template>
			</el-input>
		</template>
	</div>
</template>

<script setup lang="ts">
	import { desensitizeList, desensitizeEnum } from '../../config';

	interface Props {
		modelValue: { type?: number; regExp?: string; startNum?: number; endNum?: number };
		options: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: () => ({ type: undefined }),
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const typeChange = (e) => {
		value.value = {
			type: e,
		};
	};

	const valueChange = (type, e) => {
		value.value[type] = e;
	};
</script>

<style scoped lang="scss">
	.desensitize-header {
		display: flex;
		align-items: center;
		gap: 3px;
		margin-bottom: 1px;
	}

	.el-select {
		width: 100%;
	}

	.part-class {
		display: flex;
		gap: 5px;
	}

	.regExpClass {
		:deep(.el-input-group__prepend) {
			padding: 0 5px;
		}

		:deep(.el-input-group__append) {
			padding: 0 5px;
		}
	}
</style>
